import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { StartJobEntity } from '../../domain/entities/StartJobEntity'
import moment from 'moment'
export class StartJobModel extends StartJobEntity {
  regionId?: number
  constructor(dataDto: StartJobEntity) {
    super()
    mapEntityProperties<StartJobModel>(this, dataDto, {
      exclude: ['region'],
      map: {
        regionId: dataDto.region?.id,
        fromDate: moment(dataDto.fromDate).format('YYYY-MM-DD'),
        toDate: moment(dataDto.toDate).format('YYYY-MM-DD')
      }
    })
  }
}
